module.exports = __webpack_public_path__ + "img/luoyangyingtianmen big (7).4729ca84.jpg";